import CheckIcon from '@mui/icons-material/Check';
import { Box, FormControl } from '@mui/material/';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { BackButton } from '@/components/BackButton/BackButton';
import { LogoSvg } from '@/components/Icons/LogoSvg';
import { Input } from '@/components/StyledComponents';
import { Button } from '@/components/ui/button';
import { Text } from '@/components/ui/text';
import { paths } from '@/constants';
import type { RegistrationTypes } from '@/types';
import { validateRegistartion } from '@/utils/validators';

export const initialValues: Partial<RegistrationTypes> = {
    email: '',
};

export const PreRegistration = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const validate = validateRegistartion(t);

    const formik = useFormik({
        initialValues,
        validate,
        validateOnMount: true,
        isInitialValid: false,
        onSubmit: _values => {},
    });

    function handleClick(e: React.SyntheticEvent) {
        e.preventDefault();
        navigate(paths.sign.registration, { state: formik.values.email });
    }

    return (
        <Box p="0 15px" textAlign="center" position="relative">
            <BackButton />
            <div className="inline-block mb-[50px]">
                <LogoSvg />
            </div>
            <form noValidate autoComplete="off" onSubmit={formik.handleSubmit}>
                <FormControl>
                    <Input
                        id="email"
                        name="email"
                        type="text"
                        placeholder={t('email')}
                        inputProps={{ tabIndex: 1 }}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.email}
                        endAdornment={!formik.errors.email ? <CheckIcon color="secondary" /> : null}
                    />
                    <Box mt="40px" sx={{ '& p': { textAlign: 'center' } }}>
                        <Text variant="body2" color="text-text-secondary" children={t('helpers.registration')} />
                    </Box>
                </FormControl>

                <div className="mt-[40px]">
                    <Button onClick={handleClick} className="w-[320px]" disabled={!!formik.errors.email} variant="contained" size="large">
                        {t('buttons.create')}
                    </Button>
                </div>
            </form>

            <button
                type="button"
                className="mt-14 block w-max cursor-pointer border-none bg-transparent p-0 text-base text-primary"
                onClick={() => navigate(paths.sign.index)}
            >
                {t('helpers.have-account')}
            </button>
        </Box>
    );
};
